import axios from 'axios';

const api = '/api/competitions';

export const getCompetition = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const createCompetition = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const updateCompetition = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};
